export default __webpack_public_path__ + "static/media/hot-mop-3.eaac2cef.jpg";